'use client';

import type { StatsBlock } from '@impact/types';
import { cn } from '@/lib/utils';

interface Props {
  block: StatsBlock;
  editing?: boolean;
}

/**
 * Oversized numbers variant: enormous stat values in a tight dense grid
 */
export function StatsOversizedNumbers({ block, editing }: Props) {
  const { title, items, columns = 3 } = block.data;

  const gridClasses = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-2 lg:grid-cols-4',
  };

  return (
    <div className="my-12">
      {title ? (
        <h2
          className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-8 text-center"
          {...(editing ? { 'data-editable': 'data.title' } : {})}
        >
          {title}
        </h2>
      ) : null}
      <div className={cn('grid gap-0 divide-x divide-border', gridClasses[columns])}>
        {items.map((item, i) => (
          <div
            key={item.id}
            className="px-6 py-8 text-center"
            {...(editing ? { 'data-block-item': String(i) } : {})}
          >
            <div
              className="text-5xl md:text-7xl font-black leading-none tracking-tight text-foreground"
              {...(editing ? { 'data-editable': `data.items[${i}].value` } : {})}
            >
              {item.value}
            </div>
            <div
              className="mt-3 text-xs uppercase tracking-widest text-muted-foreground"
              {...(editing ? { 'data-editable': `data.items[${i}].label` } : {})}
            >
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
